export default "__VITE_ASSET__BBd5eik4__"